import React, { useEffect } from 'react';
import { ISelectedOption } from '../../app/@types/searchBox';
import { useTranslation } from 'react-i18next';
import { useSearchUser } from '../../app/common/hooks/useSearchUser';
import { handleOptionClickUtil } from '../../app/common/sharedComponents/SearchBox/utils';
import { SearchBox } from '../../app/common/sharedComponents/SearchBox';
import { AssignedView } from '../EditActionPlan/AssignedView';

interface ISearchBoxActionPlanUsers {
  callBackSelectedOptions?: (taggedUser: ISelectedOption[]) => void;
  initialState?: ISelectedOption[];
  disabled?: boolean;
}

export function SearchBoxActionPlanUsers ({
  callBackSelectedOptions,
  initialState = [],
  disabled = false,
}: ISearchBoxActionPlanUsers) {
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
  } = useSearchUser(initialState);

  useEffect(() => {
    if (selectedOptions && selectedOptions.length > 0) {
      if (callBackSelectedOptions) {
        callBackSelectedOptions(selectedOptions);
      }
      setSearchText('');
    }
  }, [selectedOptions]);

  function handleInputChange (value: string) {
    setSearchText(value);
  }

  function handleOptionClick (selected: ISelectedOption) {
    const selectedOption = handleOptionClickUtil(selected, selectedOptions);
    if (selectedOption.length > 0) {
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function clearSearch () {
    setSearchText('');
  }

  function removeTag (tagIndex: number) {
    const filteredRemovedTag = selectedOptions.filter(
      (_, index) => index !== tagIndex
    );

    setSelectedOptions(filteredRemovedTag);
    if (callBackSelectedOptions) {
      callBackSelectedOptions(filteredRemovedTag);
    }
  }

  return (
    <>
      {disabled ? (
        <AssignedView selectedOptions={selectedOptions} />
      ) : (
        <SearchBox
          handleInputChange={handleInputChange}
          searchBoxOptions={searchBoxOptions}
          handleOptionClick={handleOptionClick}
          selectedOptions={selectedOptions}
          searchTextName={searchText}
          clearSearch={clearSearch}
          placeholderText={t(
            'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
          )}
          showTags={true}
          removeTag={removeTag}
          disabled={disabled}
        />
      )}
    </>
  );
}
